<template>
  <div class="bar-span">
    <span class="spanTitle">{{title}}</span>
    <div class="bar-nav">
      <span
        v-for="(item,index) in barList"
        :key="index"
        :class="{active:index===currentAbout}"
        @click="goPage(item)"
      >{{item.label}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "barSpan",
  props: {
    barList: {
      type: Array
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currentAbout: ''
    };
  },
  methods: {
    goPage(item) {
      this.currentAbout = item.type;
      this.$emit("goPage", item);
    },
  }
};
</script>

<style lang="less" scoped>
.bar-span {
    text-align: left;
  .spanTitle {
    font-size: 22px;
    font-weight: 400;
    line-height: 80px;
    color: rgba(51, 51, 51, 1);
  }
  .bar-nav {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    span {
      margin-right: 27px;
      cursor: pointer;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      color: #666;
    }

    span:hover,
    .active {
      color: #5485e8;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bar-span.vue